import React from 'react'
import './Authenticate.css'
import SideNav from '../layout/SideNav'
import Card from '../core/Card'
import LoginPage from './LoginPage'
import Logo from '../core/components/Logo'
import { Switch, DatePicker, Select, Modal, Input, Icon as AIcon, Tooltip, Form, Alert, Popconfirm, Row} from 'antd';
import { Icon, BackIcon, BriefcaseIcon, CarIcon, DotIcon, ForwardIcon } from '../core/icons'
import { Field, reduxForm, submit } from 'redux-form'
import makeField from '../account/makeField'
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import { createUser } from './actions'
import { createMatchSelector } from '../rootReducer'
import {
  Button,
} from './steps/index'

const queryString = require('query-string')
const AInput = makeField(Input)

// Field size override
const layout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  }
}

const email = value =>
  value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/i.test(value)
    ? 'Invalid email address'
    : undefined

const required = value => (value ? undefined : 'Required')

export const minLength = min => value =>
  value && value.length < min ? `Too short, use at least ${min} characters` : undefined

const BackLink = ({to}) =>
  <Link style={{position:'absolute', display: 'flex', alignItems: 'center', color: '#9fabc8'}} to={to}>
    <BackIcon/> BACK
  </Link>

const Signup = ({handleSubmit, initialValues, errorMessage, h3, submitting}) =>
  <div className="Authenticate">
    <Card>
    <form onSubmit={handleSubmit}>
      <BackLink to="/start"/>
      <Row justify="center" type="flex">
        <Logo/>
      </Row>


      <Row style={{display:'flex', justifyContent:'center', paddingBottom:'20px'}}>
        <h3>{h3}</h3>
      </Row>

      <Field
        layout={layout}
        placeholder="email@email.com"
        name="email"
        type="email"
        component={AInput}
        autoFocus={!initialValues.email}
        validate={[email, required]}
        disabled={!!initialValues.email}
      />
      <Field
        layout={layout}
        validate={[minLength(6), required]}
        name="password"
        autoFocus={!!initialValues.email}
        component={AInput}
        placeholder="Choose your password"
        type="password"
      />
      <Button primary fullWidth loading={submitting} htmlType="submit">Sign Up</Button>

      {errorMessage && <Alert style={{marginTop:'20px'}} message={errorMessage} type="error" />}

      <span style={{display:'flex', justifyContent:'center', paddingTop:'20px'}}>
        By signing up you agree to the
        <a
          style={{paddingLeft:'5px', textDecoration:'underline'}}
          target="_blank" href="https://everlance.com/terms-of-service"> Terms & Conditions</a>
      </span>
    </form>
    </Card>
  </div>

// const mapStateToProps = (state, ownProps) => {
//   const query = queryString.parse(ownProps.location.search)
//   const signupType = query.signup_type
//
//   const redirectToQuery = query.signup_type || query.redirect_to
//   const { from } = ownProps.location.state ||  { from: { pathname: redirectToQuery || '/premium' } }
//   return {
//     h3: (signupType == 'accountants') ? "Accountant Sign Up" : "Welcome to Everlance!",
//     isFetching: state.models.user.isFetching,
//     signupErrorMessage: state.models.user.signupErrorMessage,
//     locationSearch: ownProps.location.search,
//     from,
//     query
//   }
// }

const mapStateToProps = (state, ownProps) => {
  const match = createMatchSelector('/signup/:signupType')(state)
  const signupTypeParam = match && match.params.signupType
  // const query = queryString.parse(ownProps.location.search)

  return {
    initialValues: {
      email: state.user.email
    },
    h3: (state.user.signup_type||signupTypeParam)=='accountants'
      ? 'Accountant Sign Up':'Create New Account',
    // h3: query.signup_type=='accountants' ? 'Accountant Sign Up':'Create New Account',
    // isFetching: state.models.user.isFetching,
    errorMessage: state.models.user.signupErrorMessage,
  }
}

export default connect( mapStateToProps )(
  reduxForm({
    form: 'signup',
    onSubmit: (values, dispatch)=> dispatch(createUser(values)),
  })(Signup)
)



// WEBPACK FOOTER //
// ./src/user/Signup.js